module.exports = __webpack_public_path__ + "static/media/money-pence-ten.9910c422.svg";